import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import { FilterTransformation } from 'app/model/dataflow/filtertransformation';
import { FilterPlainObject } from 'worker/app-workers/shared/plainObjects/filter.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class FilterConvertor extends TransformConvertorBase {
    private get filterTransform(): FilterTransformation {
        return this.transformation as FilterTransformation;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        this.filterTransform.condition.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
            (this.transformObject as FilterPlainObject).conditionExpression
        );
        super.postConvert();
        return this.transformation;
    }
}
